import React, { useState } from 'react';

import './Program.teams.scss';
import {Subject} from "rxjs";
import {useQuery} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import ButtonIcon from "../../forms/buttons/Button.icon";
import SpinnerLoader from "../../visuals/SpinnerLoader";
import Checkbox from "../../forms/inputs/Checkboxk";
import ItemMenu from "../../forms/menu/MenuComponent";
import ProgramTeamItem from "./Program.teams.item";
import ItemDeleteDialog from "../dialogs/Team.delete.dialog";
import {clearGqlTypename} from "../../utils/clearTypename";
import ProgramMembersDialog from "../dialogs/Program.members.dialog";
import {useTranslation} from "react-i18next";
import {PageViewLog} from "../../services/interactions/page.view";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";
import {useParams} from "react-router-dom";


function ProgramTeams({currentOrg, currentUser}) {
    let {programId} = useParams();
    const {t} = useTranslation(['common','teams']);
    const [sortAscending, setSortAscending] = useState(true);
    const [sorting, setSorting] = useState('name');

    const [searchFocused, changeSearchFocused] = useState(false);
    const [search, changeSearch] = useState('');
    const [searchTerm] = useState(new Subject());

    const [program, setProgram] = useState(null);
    const [loadData, setLoadData] = useState(true);
    const [teams, setTeams] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [hoverTeam, setHoverTeam] = useState(null);
    const [selectedTeams, setSelectedTeams] = useState([]);
    const [openMembersModal, setOpenMembersModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectAll, setSelectAll] = useState(false);

    useQuery(gqlSchemaLibrary.programs.query.getProgramById, {
        variables: {
            id: programId
        },
        onCompleted: ({ getProgramById }) => {
            setProgram(clearGqlTypename(getProgramById));
            setTeams(clearGqlTypename(getProgramById.teams));
            setLoadData(false);
        },
        fetchPolicy: 'cache-and-network'
    })

    const handleFocus = (bool) => {
        return () => {
            AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'input', event: 'onSearch', action: 'input search teams', focus: bool, value: search});
            changeSearchFocused(bool);
        }
    }

    const handleSearch = (e) => {
        const value = e.target.value;
        changeSearch(value)
        searchTerm.next(value);
    }

    const sortList = (key) => {
        return () => {
            AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'button', event: 'onClick', action: 'button toggle sort', sort: key, sort_ascending: !sortAscending});
            setSorting(key);
            setSortAscending(!sortAscending);
        }
    }

    const onChange = (team) => {
        const _team = selectedTeams.find((t) => t._id === team._id);
        const index = selectedTeams.indexOf(_team);
        const checked = index > -1;
        AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'checkbox', event: 'onCheck', action: 'button selected user', program_id: program._id, team_id: team._id, check: !checked});
        if (index > -1) {
            selectedTeams.splice(index, 1);
        } else {
            selectedTeams.push(team);
        }
        if (!selectedTeams.length) {
            setSelectAll(false);
        }
        setSelectedTeams(Object.assign([], selectedTeams));
    }

    const onDeleteTeams = () => {
        if (selectedTeams.length) {
            setOpenDeleteModal(true);
        }
    }

    const onSelectAll = () => {
        const status = !selectAll;
        if (status) {
            setSelectedTeams(Object.assign([], teams));
        } else {
            setSelectedTeams([]);
        }
        AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'checkbox', event: 'onCheck', action: 'button selected all teams', program_id: program._id, check: status});
        setSelectAll(status);
    }

    const onOpenMembersModal = () => {
        setOpenMembersModal(true);
    }

    const onCloseModal = (program, users, teams) => {
        if (program && teams) {
            program.teams = teams;
            setTeams(teams)
            setProgram(program);
        }
        setOpenMembersModal(false);
    }

    const onOpenDeleteModal = (user) => {
        setSelectedTeam(user);
        setOpenDeleteModal(true);
    }

    const closeDeleteModal = (_items) => {
        if (_items) {
            for (const _u of _items) {
                const _user = teams.find((u) => u._id === _u._id);
                const index = teams.indexOf(_user);
                if (index > -1) {
                    teams.splice(index, 1);
                }
            }
            setTeams(teams);
        }
        setSelectedTeam(null);
        setOpenDeleteModal(false);
    }

    const filteredTeams= teams.filter(p => {
        if (!search) {
            return true;
        }
        const name = (p.name || '').toLowerCase();
        return name.includes(search);
        })
        .sort( (a, b) => {
            if(!sorting){
                return true;
            }
            if(sorting === 'name'){
                const aName = a.name;
                const bName = b.name;
                if(sortAscending){
                    return aName.localeCompare(bName);
                }else{
                    return bName.localeCompare(aName);
                }
            }
            return true;
        })

    const onBack = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_TEAMS, {tag: 'button', event: 'onClick', action: 'button cancel program teams'});
        window.history.back();
    }

    return (
        <div id="UsersProgram">
            <div className="filter">
                <div className="programOptions">
                    <i className="material-icons" onClick={onBack}>
                        arrow_back_ios
                    </i>
                    <div className="progTitle">
                        <h3>{!!program && program.name ? program.name : ''}</h3>
                        <div className="_active">
                            {t('active')}
                    </div>
                    </div>
                </div>
                <div className={`programFilters ${currentUser.userRoles.userPatients.edit ? '' : '_col3'}`}>
                    <div className="searchFilters">
                        <div></div>
                        <div className="searchContainer">
                            <div className={`search ${searchFocused ? 'focused' : ''}`}>
                                <input value={search} placeholder={t('search')} onChange={handleSearch} onFocus={handleFocus(true)} onBlur={handleFocus(false)} />
                                <i className="material-icons">
                                    search
                            </i>
                            </div>
                        </div>
                    </div>
                    <p className="_counter">
                        {filteredTeams.length} team{filteredTeams.length === 1? '' : 's'}
                    </p>
                    {
                        currentUser.userRoles.userPatients.edit?
                            <div className="enrollAction" onClick={onOpenMembersModal}>
                                <ButtonIcon>
                                    <span className="material-icons">
                                        add
                                </span>
                                </ButtonIcon>
                                <p>{t('teams:team-add')}</p>
                            </div> : <div className="empty"></div>
                    }
                </div>
            </div>
            <div className="patientsList scrollBar">
                <div className="headers">
                    <div>
                        {
                            currentUser.userRoles.userPatients.edit? <Checkbox bool={selectAll} onChange={onSelectAll}/> : ''
                        }
                    </div>
                    <div className="selectable sortable">
                        <p onClick={sortList('name')}>
                            {t('name')}
                        </p>
                        <div className="_updown" onClick={sortList('name')}>
                            <span className="_up material-icons">expand_less</span>
                            <span className="_down material-icons">expand_more</span>
                        </div>
                    </div>
                    <div className="selectable">
                        <p>
                            {t('teams:members')}
                        </p>
                        <div className="_updown"></div>
                    </div>
                    <div>
                        {
                            currentUser.userRoles.userPatients.edit && selectedTeams.length?
                                <ItemMenu actionWillRedirect={false} fixed={true}>
                                    <>
                                        <div className="_option" onClick={onDeleteTeams} >
                                            <p>{t('teams:remove-teams')}</p>
                                        </div>
                                    </>
                                </ItemMenu> : ''
                        }
                    </div>
                </div>
                {
                    filteredTeams.map((t) => (
                        <ProgramTeamItem key={t._id} currentUser={currentUser} team={t} selectedTeams={selectedTeams} hoverTeam={hoverTeam} onHover={setHoverTeam} onDeleteItem={onOpenDeleteModal} onChange={onChange} />
                    ))
                }
                {loadData ? <SpinnerLoader /> : ''}
            </div>
            {
               <ItemDeleteDialog type={'team'} program={program} item={selectedTeam} items={selectedTeams} openModal={openDeleteModal} closeModal={closeDeleteModal} />
            }
            {
                program? <ProgramMembersDialog type={'team'} program={program} openModal={openMembersModal} closeModal={onCloseModal} /> : ''
            }
        </div>
    );
}

export default PageViewLog(ProgramTeams);
